
import { Colors } from '@doordash/design-language'
import styled from 'styled-components'

export const FAQLink = styled.a`
    color: ${Colors.SystemRed60};
`